/** 个人中心页 + 弹窗 — 与 forttrade-dapp `Profile` 深色终端色板对齐 */
export const C = {
  bg: "#0a0b0e",
  card: "#0f1117",
  card2: "#161a22",
  border: "rgba(255,255,255,0.07)",
  text: "#e2e8f0",
  muted: "#94a3b8",
  dim: "#64748b",
  primary: "#22c55e",
  green: "#22c55e",
  red: "#ef4444",
  amber: "#f59e0b",
  cyan: "#2196f6",
};
